import {z} from 'zod';

export const LinkNoticeSchema = z.object({
  id: z.number(),
  message: z.string(),
  url: z.string(),
});

export const GetLinkNoticeResponseSchema = z.object({
  linkNotice: LinkNoticeSchema.nullable(),
});

export type LinkNoticeType = z.infer<typeof LinkNoticeSchema>;
export type GetLinkNoticeResponseType = z.infer<
  typeof GetLinkNoticeResponseSchema
>;
